module.exports = __webpack_public_path__ + "static/media/Visa_logo.6f41de1b.svg";